<template>
  <div class="d-flex flex-column justify-center align-center pt-5">
    <div class="d-flex flex-row justify-center align-center pt-5">
      <v-btn
        color="orange"
        class="mr-4"
        width="200"
        @click="tab = 'kerry'"
      >
        ข้อมูลลูกค้า
      </v-btn>
      <v-btn
        color="success"
        class="mr-4"
        width="200"
        @click="tab = 'sale'"
      >
        ข้อมูลการสั่งซื้อ
      </v-btn>
      <v-btn
        color="success"
        class="mr-4"
        width="200"
        @click="tab = 'b_status'"
      >
        ข้อมูลสถานะ B
      </v-btn>
      <v-btn
        color="success"
        class="mr-4"
        width="200"
        @click="tab = 'new_each_month'"
      >
        เบอร์ใหม่แต่ละเดือน
      </v-btn>
      <v-btn
        color="success"
        class="mr-4"
        width="200"
        @click="tab = 'appointment'"
      >
        ประวัติการนัดหมาย
      </v-btn>
      <v-btn
        color="success"
        class="mr-4"
        width="200"
        @click="tab = 'remove_reason'"
      >
        ประวัติการลบข้อมูล
      </v-btn>
      <v-btn
        color="blue"
        class="mr-4"
        width="200"
        @click="go_to_add_datapool()"
      >
        เพิ่มชื่อใหม่
      </v-btn>
      <v-btn
        color="blue"
        class="mr-4"
        width="200"
        @click="assign_work_dialog = true"
      >
        Assign งานให้ TeleSale
      </v-btn>
    </div>
    <div class="d-flex flex-row justify-center align-center pt-5">
      <v-btn
        color="blue"
        class="mr-4"
        width="200"
        @click="handleAssignSourceMulti()"
      >
        เปลี่ยน Souce Multi
      </v-btn>
      <v-btn
        color="blue"
        class="mr-4"
        width="200"
        @click="handleAssignSaleMulti()"
      >
        เปลี่ยน Sale Multi
      </v-btn>
    </div>
    <div class="d-flex flex-row pt-5" style="width: 70%;">
      <v-textarea
        v-model="search_keyword"
        label="ค้นหาชื่อ/เบอร์โทร"
        required
        full-width
        rows="1"
        auto-grow
      ></v-textarea>
      <v-btn
        color="yellow"
        class="ma-4"
        width="200"
        @click="getLeadListAdmin(), getSaleTransaciontAdmin(), getRemoveReasonAdmin(), getAppointmentAdmin()"
      >
        ค้นหา
      </v-btn>
    </div>
    <div class="d-flex flex-row justify-center align-center pt-5">
      
      <v-btn
        color="red"
        class="ma-4"
        width="200"
        @click="import_dialog = true"
      >
        นำเข้าข้อมูลลูกค้า
      </v-btn>
      <v-btn
        color="pink"
        class="ma-4"
        width="200"
        @click="exportCreateTransactionCSV()"
      >
        export ข้อมูลการสั่งซื้อ
      </v-btn>
      <v-btn
        color="pink"
        class="ma-4"
        width="250"
        @click="exportDataPoolPSCSV()"
      >
        export ข้อมูล P/S ที่ครบกำหนด
      </v-btn>
      <v-btn
        color="pink"
        class="ma-4"
        width="250"
        @click="reset_D_dialog = true"
      >
        ล้างข้อมูล D แล้วแจกใหม่
      </v-btn>
    </div>
    <div v-if="loading_kerry == false">
      <v-data-table
        :headers="dataTableHeader"
        :items="dataPool"
        item-key="id"
        class="elevation-1"
        v-if="tab == 'kerry'"
        @click:row="selectRow"
      >
      </v-data-table>
      <v-data-table
        :headers="saleTransactionHeader"
        :items="saleTransactionData"
        item-key="id"
        class="elevation-1"
        v-if="tab == 'sale'"
        @click:row="selectRow_transaction"
      >
      </v-data-table>
      <v-data-table
        v-model="selected_b"
        :headers="dataTableHeader"
        :items="dataPool_status_b"
        item-key="id"
        multi-sort
        show-select
        class="elevation-1"
        v-if="tab == 'b_status'"
        @click:row="selectRow"
      >
      </v-data-table>
      <v-btn
        color="pink"
        class="ma-4"
        width="250"
        v-if="tab == 'b_status'"
        @click="assign_lead_dialog_multi = true"
      >
        นำข้อมูล B ออกหลายอัน
      </v-btn>
      <v-data-table
        :headers="leadListMonthHeader"
        :items="leadListMonth"
        item-key="id"
        multi-sort
        class="elevation-1"
        v-if="tab == 'new_each_month'"
        @click:row="selectRowMonth"
      >
      </v-data-table>
      <v-select
        v-model="remove_reason_unique_item"
        :items="remove_reason_unique"
        outlined
        v-if="tab == 'remove_reason'"
        @change="change_remove_reason"
        class='pa-5'
      ></v-select>
      <v-data-table
        :headers="removeTableHeader"
        :items="removeReasonData"
        item-key="id"
        multi-sort
        class="elevation-1"
        v-if="tab == 'remove_reason'"
      >
      </v-data-table>
      <v-data-table
        :headers="appointmentTableHeader"
        :items="appointmentData"
        item-key="id"
        multi-sort
        class="elevation-1"
        v-if="tab == 'appointment'"
      >
      </v-data-table>
    </div>
    <v-progress-circular
      indeterminate
      color="primary"
      v-if="loading_kerry == true"
    ></v-progress-circular>
    <v-dialog
      v-model="customer_detail"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          รายละเอียดลูกค้า
        </v-card-title>
        <div class="d-flex flex-row justify-center pa-3">
          <div class="d-flex flex-column">
            ข้อมูลลูกค้า
            <v-data-table
              :headers="customer_detail_data_pool_Header"
              :items="customer_detail_data_pool"
              item-key="name"
              class="elevation-1 pa-3"
            >
            </v-data-table>
          </div>
          <div class="d-flex flex-column ml-3">
            ข้อมูลลูกค้าจาก Form ที่ส่งไป
            <v-data-table
              :headers="customer_detail_sale_transaction_Header"
              :items="customer_detail_sale_transaction"
              
              item-key="name"
              class="elevation-1 pa-3"
              @click:row="updateTransaction"
            >
            </v-data-table>
          </div>
          <div>
            note: {{ note }}
          </div>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-show="imagePath != null"
            color="primary"
            text
            @click="openTransactionImage"
          >
            sale slip
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="customer_detail = false, appointment = false"
          >
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="assign_lead_dialog"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          มอบหมายงานของเบอร์ {{ mobileSelected }} / {{ nameSelected }}
        </v-card-title>
        <v-select
          v-model="saleSelected"
          :items="saleList"
          label="รายชื่อ sale"
          item-text="name"
          item-value="uid"
          required
          outlined
          class='pa-5'
        ></v-select>
        <v-select
          v-model="sourceSelect"
          :items="source"
          label="รายชื่อ source"
          item-text="username"
          item-value="username"
          required
          outlined
          class='pa-5'
        ></v-select>
        <v-select
          v-model="status"
          :items="statusList"
          label="สถานะ"
          required
          outlined
          class='pa-5'
        ></v-select>
        <v-text-field
          class='pa-5'
          v-model="assign_note"
          label="note"
        ></v-text-field>
        <v-date-picker
          v-model="date_pick"
          :show-current="false"
        ></v-date-picker>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="d-flex flex-row justify-center pa-3">
            <v-btn
              color="yellow"
              class="mr-4"
              @click="assign_mobile_to_sale()"
            >
              assign งาน
            </v-btn>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="assign_lead_dialog = false"
          >
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="assign_lead_dialog_multi"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          มอบหมายงานของเบอร์ - 
          <div v-for="item in selected_b" :key="item.id">
             {{ item.mobile }},
          </div>
          
        </v-card-title>
        <v-select
          v-model="saleSelected"
          :items="saleList"
          label="รายชื่อ sale"
          item-text="name"
          item-value="uid"
          required
          outlined
          class='pa-5'
        ></v-select>
        <v-select
          v-model="status"
          :items="statusList"
          label="สถานะ"
          required
          outlined
          class='pa-5'
        ></v-select>
        <v-text-field
          class='pa-5'
          v-model="assign_note"
          label="note"
        ></v-text-field>
        <v-date-picker
          v-model="date_pick"
          :show-current="false"
        ></v-date-picker>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="d-flex flex-row justify-center pa-3">
            <v-btn
              color="yellow"
              class="mr-4"
              @click="assign_mobile_to_sale_multi()"
            >
              assign งาน
            </v-btn>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="assign_lead_dialog_multi = false"
          >
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="import_dialog"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          import csv
        </v-card-title>
        <v-file-input
          v-model="import_file"
          show-size
          label="file ที่ต้องการนำเข้า"
        ></v-file-input>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="d-flex flex-row justify-center pa-3">
            <v-btn
              color="yellow"
              class="mr-4"
              @click="importLead()"
            >
              import ข้อมูล
            </v-btn>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="import_dialog = false"
          >
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="reset_D_dialog"
      width=500
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          ต้องการล้างข้อมูล D ใช่หรือไม่
        </v-card-title>
        <v-card-actions>
          <div v-show="loading_reset_d == false">
            <div class="d-flex flex-row justify-center pa-3">
              <v-btn
                color="yellow"
                class="mr-4"
                @click="resetDAndAssignCron()"
              >
                ใช่
              </v-btn>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="reset_D_dialog = false"
            >
              ไม่ใช่
            </v-btn>
          </div>
           <v-progress-circular
            indeterminate
            color="primary"
            v-show="loading_reset_d == true"
          ></v-progress-circular>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="assign_work_dialog"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Manual Add Mobile To TeleSale
        </v-card-title>
        <div class='d-flex flex-row'>
          <v-select
            v-model="saleSelected"
            :items="saleList"
            label="รายชื่อ sale"
            item-text="name"
            item-value="uid"
            required
            outlined
            class='pa-5'
          ></v-select>
          <v-text-field
            v-model="work_count"
            label="จำนวนงานที่ต้องการเพิ่ม"
            required
          ></v-text-field>
          <v-select
            v-model="sourceSelect"
            :items="source"
            label="รายชื่อ source"
            item-text="username"
            item-value="username"
            required
            outlined
            class='pa-5'
          ></v-select>
        </div>
        
        <v-divider></v-divider>
        <v-card-actions>
          <div class="d-flex flex-row justify-center pa-3">
            <v-btn
              color="yellow"
              class="mr-4"
              @click="assign_work_manual()"
            >
              Assign งาน
            </v-btn>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="assign_work_dialog = false"
          >
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="assign_source_multi_dialog"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          เปลี่ยน Source
        </v-card-title>
        <div class='d-flex flex-row'>
          <v-select
            v-model="sourceSelect"
            :items="source"
            label="รายชื่อ source"
            item-text="username"
            item-value="username"
            required
            outlined
            class='pa-5'
          ></v-select>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="dataTableHeaderChangeMulti"
          :items="dataPool"
          item-key="id"
          class="elevation-1"
        >
        </v-data-table>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="d-flex flex-row justify-center pa-3">
            <v-btn
              color="yellow"
              class="mr-4"
              @click="assign_source_multi()"
            >
              เปลี่ยน Source
            </v-btn>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="assign_source_multi_dialog = false"
          >
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="assign_sale_multi_dialog"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          เปลี่ยน Sale
        </v-card-title>
        <div class='d-flex flex-row'>
          <v-select
            v-model="saleSelected"
            :items="saleList"
            label="รายชื่อ sale"
            item-text="name"
            item-value="uid"
            required
            outlined
            class='pa-5'
          ></v-select>
          <v-select
            v-model="statusFilterSelected"
            :items="statusFilterList"
            label="สถานะเพื่อ Filter"
            item-text="name"
            item-value="uid"
            required
            outlined
            class='pa-5'
            @change="onStatusFilterChanged()"
          ></v-select>
          <v-select
            v-model="statusAfterSelected"
            :items="statusAfterList"
            label="สถานะที่ต้องการเปลี่ยน"
            item-text="name"
            item-value="uid"
            required
            outlined
            class='pa-5'
          ></v-select>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="dataTableHeaderChangeMulti"
          :items="dataPool"
          item-key="id"
          class="elevation-1"
        >
        </v-data-table>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="d-flex flex-row justify-center pa-3">
            <v-btn
              color="yellow"
              class="mr-4"
              @click="assign_sale_multi()"
            >
              เปลี่ยน Sale
            </v-btn>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="restoreDatapool()"
          >
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="assign_work_dialog_month"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          ข้อมูลรายละเอียดเบอร์ในเดือนที่เลือก
        </v-card-title>
        <div class='d-flex flex-row'>
          <v-data-table
            :headers="lead_month_info_Header"
            :items="lead_month_info"
            @click:row="selectRowMonthFilter"
            v-show="month_filter == false"
            item-key="name"
            class="elevation-1 pa-3"
          >
          </v-data-table>
          <v-btn
            color="green"
            v-show="month_filter == true"
            @click="month_filter = false"
          >
            กลับ
          </v-btn>
          <v-data-table
            :headers="dataTableHeader"
            :items="lead_month_info_filter"
            v-show="month_filter == true"
            item-key="name"
            class="elevation-1 pa-3"
          >
          </v-data-table>
        </div>
        <v-divider></v-divider>

        <div class='d-flex flex-row'>
          <v-select
            v-model="saleSelected"
            :items="saleList"
            label="รายชื่อ sale"
            item-text="name"
            item-value="uid"
            required
            outlined
            class='pa-5'
          ></v-select>
          <v-text-field
            v-model="work_count"
            label="จำนวนงานที่ต้องการเพิ่ม"
            required
          ></v-text-field>
        </div>
        
        <v-divider></v-divider>
        <v-card-actions>
          <div class="d-flex flex-row justify-center pa-3">
            <v-btn
              color="yellow"
              class="mr-4"
              @click="assign_work_manual_month()"
            >
              Assign งาน
            </v-btn>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="import_dialog = false"
          >
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
    >
      {{ snackbar_text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          ปิด
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    data: () => ({
      tab: 'kerry',
      snackbar: false,
      snackbar_text: '',
      import_dialog: false,
      reset_D_dialog: false,
      assign_work_dialog: false,
      assign_work_dialog_month: false,
      assign_source_multi_dialog: false,
      assign_sale_multi_dialog: false,
      import_file: null,
      loading_kerry: false,
      loading_sale: false,
      loading_reset_d: false,
      search_keyword: '',
      dataPool : [],
      dataPool_tmp : [],
      dataPool_search : [],
      dataPool_status_b : [],
      removeReasonData : [],
      removeReasonDataTemplate: [],
      appointmentData : [],
      saleSelected: {},
      saleTransactionData: [],
      leadListMonth: [],
      saleList: [],
      customer_detail: false,
      note: '',
      assign_note: '',
      month_filter: false,
      work_count: '20',
      select_month_info_month: '',
      select_month_info_source: '',
      select_month_info_status: '',
      selected_b: [],
      remove_reason_unique_item: '',
      remove_reason_unique: [],
      statusFilterList: ['ทั้งหมด','A', 'D', 'P', 'W', 'Z', 'B'],
      statusFilterSelected: '',
      statusAfterList: ['A', 'D', 'P', 'W', 'Z', 'B'],
      statusAfterSelected: '',
      dataTableHeader : [
        {
          text: 'ชื่อลูกค้า',
          align: 'start',
          value: 'name',
        },
        {
          text: 'address1',
          align: 'start',
          value: 'address1',
        },
        {
          text: 'address2',
          align: 'start',
          value: 'address2',
        },
        {
          text: 'ตำบล',
          align: 'start',
          value: 'subdistrict',
        },
        {
          text: 'อำเภอ',
          align: 'start',
          value: 'district',
        },
        {
          text: 'จังหวัด',
          align: 'start',
          value: 'province',
        },
        {
          text: 'รหัสไปรษณีย์',
          align: 'start',
          value: 'postcode',
        },
        {
          text: 'เบอร์โทรศัพท์',
          align: 'start',
          value: 'mobile',
        },
        {
          text: 'มูลค่า (บาท)',
          align: 'start',
          value: 'amount',
        },
        {
          text: 'สถานะรายการ',
          align: 'start',
          value: 'status',
        },
        {
          text: 'วันนัดหมาย',
          align: 'start',
          value: 'noti_date',
        },
        {
          text: 'note',
          align: 'start',
          value: 'note',
        },
        {
          text: 'sale',
          align: 'start',
          value: 'username',
        },
        {
          text: 'source',
          align: 'start',
          value: 'source',
        },
        {
          text: 'product',
          align: 'start',
          value: 'product',
        },
        {
          text: 'โยนไป A',
          align: 'start',
          value: 'remove_from_b',
        },
        {
          text: 'deadline',
          align: 'start',
          value: 'deadline',
        },
      ],
      dataTableHeaderChangeMulti : [
        {
          text: 'ชื่อลูกค้า',
          align: 'start',
          value: 'name',
        },
        {
          text: 'เบอร์โทรศัพท์',
          align: 'start',
          value: 'mobile',
        },
        {
          text: 'มูลค่า (บาท)',
          align: 'start',
          value: 'amount',
        },
        {
          text: 'สถานะรายการ',
          align: 'start',
          value: 'status',
        },
        {
          text: 'วันนัดหมาย',
          align: 'start',
          value: 'noti_date',
        },
        {
          text: 'note',
          align: 'start',
          value: 'note',
        },
        {
          text: 'sale',
          align: 'start',
          value: 'username',
        },
        {
          text: 'source',
          align: 'start',
          value: 'source',
        },
      ],
      removeTableHeader : [
        {
          text: 'ชื่อพนักงาน',
          align: 'start',
          value: 'username',
        },
        {
          text: 'เบอร์',
          align: 'start',
          value: 'mobile',
        },
        {
          text: 'วิธีการลบ',
          align: 'start',
          value: 'to_status',
        },
        {
          text: 'วันที่ลบ',
          align: 'start',
          value: 'date',
        },
        {
          text: 'เหตุผล',
          align: 'start',
          value: 'remove_reason',
        },
      ],
      leadListMonthHeader : [
        {
          text: 'เดือน',
          align: 'start',
          value: 'txn_month',
        },
        {
          text: 'จำนวนเบอร์ที่ยังเหลือ',
          align: 'start',
          value: 'monthly_sum',
        },
        {
          text: 'source',
          align: 'start',
          value: 'source',
        },
      ],
      appointmentTableHeader : [
        {
          text: 'ชื่อพนักงาน',
          align: 'start',
          value: 'username',
        },
        {
          text: 'เบอร์',
          align: 'start',
          value: 'mobile',
        },
        {
          text: 'from',
          align: 'start',
          value: 'from',
        },
        {
          text: 'to',
          align: 'start',
          value: 'to',
        },
        {
          text: 'เหตุผล',
          align: 'start',
          value: 'note',
        },
      ],
      saleTransactionHeader : [
        {
          text: 'ชื่อลูกค้า',
          align: 'start',
          value: 'name',
        },
        {
          text: 'address1',
          align: 'start',
          value: 'address1',
        },
        {
          text: 'address2',
          align: 'start',
          value: 'address2',
        },
        {
          text: 'ตำบล',
          align: 'start',
          value: 'subdistrict',
        },
        {
          text: 'อำเภอ',
          align: 'start',
          value: 'district',
        },
        {
          text: 'จังหวัด',
          align: 'start',
          value: 'province',
        },
        {
          text: 'รหัสไปรษณีย์',
          align: 'start',
          value: 'postcode',
        },
        {
          text: 'เบอร์โทรศัพท์',
          align: 'start',
          value: 'mobile',
        },
        {
          text: 'ราคา (บาท)',
          align: 'start',
          value: 'price',
        },
        {
          text: 'ค่าใช้จ่ายอื่นๆ (บาท)',
          align: 'start',
          value: 'price_other',
        },
        {
          text: 'ประเภทสินค้า',
          align: 'start',
          value: 'product_type',
        },
        {
          text: 'รายการสินค้า',
          align: 'start',
          value: 'product',
        },
        {
          text: 'วิธีการชำระเงิน',
          align: 'start',
          value: 'payment_method',
        },
        {
          text: 'หมายเหตุ',
          align: 'start',
          value: 'note',
        },
        {
          text: 'เวลาส่งข้อมูล',
          align: 'start',
          value: 'insert_time',
        },
        {
          text: 'sale',
          align: 'start',
          value: 'username',
        },
        {
          text: 'sale',
          align: 'start',
          value: 'image_path',
        },
      ],
      customer_detail_sale_transaction: [],
      customer_detail_data_pool: [],
      customer_detail_data_pool_Header : [
        {
          text: 'ชื่อลูกค้า',
          align: 'start',
          value: 'name',
        },
        {
          text: 'เบอร์โทรศัพท์',
          align: 'start',
          value: 'mobile',
        },
        {
          text: 'วันที่รับข้อมูลเข้าระบบ',
          align: 'start',
          value: 'date',
        },
        {
          text: 'ที่อยู่',
          align: 'start',
          value: 'address1',
        },
        {
          text: 'จังหวัด',
          align: 'start',
          value: 'province',
        },
        {
          text: 'ราคา',
          align: 'start',
          value: 'amount',
        },
        {
          text: 'symbol',
          align: 'start',
          value: 'symbol',
        },
      ],
      customer_detail_sale_transaction_Header : [
        {
          text: 'id',
          align: 'start',
          value: 'id',
        },
        {
          text: 'ชื่อลูกค้า',
          align: 'start',
          value: 'name',
        },
        {
          text: 'เบอร์โทรศัพท์',
          align: 'start',
          value: 'mobile',
        },
        {
          text: 'บ้านเลขที่',
          align: 'start',
          value: 'address1',
        },
        {
          text: 'ตำบล',
          align: 'start',
          value: 'subdistrict',
        },
        {
          text: 'อำเภอ',
          align: 'start',
          value: 'district',
        },
        {
          text: 'จังหวัด',
          align: 'start',
          value: 'province',
        },
        {
          text: 'รหัสไปรษณีย์',
          align: 'start',
          value: 'postcode',
        },
        {
          text: 'วันที่สั่งสินค้า',
          align: 'start',
          value: 'insert_time',
        },
        {
          text: 'ชนิดผลิตภัณฑ์',
          align: 'start',
          value: 'product_type',
        },
        {
          text: 'ผลิตภัณฑ์',
          align: 'start',
          value: 'product',
        },
        {
          text: 'ราคา',
          align: 'start',
          value: 'price',
        },
        {
          text: 'ค่าใช้จ่ายอื่นๆ',
          align: 'start',
          value: 'price_other',
        },
        {
          text: 'วิธีการชำระเงิน',
          align: 'start',
          value: 'payment_method',
        },
      ],
      lead_month_info : [],
      lead_month_info_Header : [
        {
          text: 'สถานะ',
          align: 'start',
          value: 'status',
        },
        {
          text: 'จำนวนเบอร์',
          align: 'start',
          value: 'count',
        },
      ],
      lead_month_info_filter : [],
      lead_month_info_fulter_Header : [
        {
          text: 'สถานะ',
          align: 'start',
          value: 'status',
        },
        {
          text: 'จำนวนเบอร์',
          align: 'start',
          value: 'count',
        },
      ],
      assign_lead_dialog: false,
      assign_lead_dialog_multi: false,
      mobileSelected: '',
      nameSelected: '',
      loading_sale_user: false,
      date_pick: '',
      status: 'A',
      statusList: ['A', 'D', 'P', 'Z'],
      imagePath: null,
      source: [],
      sourceSelect: '',
      assign_source: [],
      assign_sourceSelect: '',
    }),
    mounted () {
      this.getLeadListAdmin()
      this.getSourceList()
      this.getSaleTransaciontAdmin()
      this.getSaleListAdmin()
      this.getSaleListMonth()
      this.getRemoveReasonAdmin()
      this.getAppointmentAdmin()
    },
    methods: {
      restoreDatapool() {
        this.assign_sale_multi_dialog = false;
        this.dataPool = this.dataPool_search;
        this.statusFilterSelected = '';
        this.statusAfterSelected = '';
      },
      onStatusFilterChanged() {
        if (this.statusFilterSelected === 'ทั้งหมด') {
          this.dataPool = this.dataPool_search;
          return;
        }
        else {
          this.dataPool = this.dataPool_search.filter(item => item.status === this.statusFilterSelected);
        }
      },
      handleAssignSourceMulti() {
        if (this.dataPool.length < 50000 && this.dataPool.length > 0) {
          this.assign_source_multi_dialog = true;
        } else {
          // ถ้าอยากแจ้งเตือนด้วย อาจจะใส่
          this.snackbar = true
          this.snackbar_text = 'ต้องค้นหาด้วยเบอร์โทรก่อน'
          // หรือ alert ธรรมดา
          // alert('จำนวนรายการต้องน้อยกว่า 10,000');
        }
      },
      handleAssignSaleMulti() {
        if (this.dataPool.length < 50000 && this.dataPool.length > 0) {
          this.assign_sale_multi_dialog = true;
        } else {
          // ถ้าอยากแจ้งเตือนด้วย อาจจะใส่
          this.snackbar = true
          this.snackbar_text = 'ต้องค้นหาด้วยเบอร์โทรก่อน'
          // หรือ alert ธรรมดา
          // alert('จำนวนรายการต้องน้อยกว่า 10,000');
        }
      },
      updateTransaction(value) {
        console.log(value)
        this.$store.commit('SET_adminUpdateTransaction', value)
        
        this.$router.push('/updateTransactionAdmin')
      },
      selectRow(value) {
        console.log('select row')
        console.log(value)
        // this.date_from = value.noti_date
        this.mobileSelected = value.mobile
        this.nameSelected = value.name
        this.assign_lead_dialog = true
      },
      selectRow_transaction(value) {
        console.log('select row')
        console.log(value)
        this.note = value.note
        this.mobileSelected = value.mobile
        this.imagePath = value.image_path_real
        this.customer_detail = true
        this.get_customer_detail()
      },
      selectRowMonth(value) {
        console.log('select month')
        console.log(value)
        //saleTransactionData
        this.select_month_info_month = value.txn_month
        this.select_month_info_source = value.source
        this.get_lead_month_info()
      },
      selectRowMonthFilter(value) {
        console.log('select month')
        console.log(value)
        //saleTransactionData
        this.select_month_info_status = value.status
        this.get_lead_month_info_filter()
      },
      openTransactionImage() {
        window.open(this.imagePath.replace("-", "_"))
      },
      async get_customer_detail () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)
        console.log()
        const customer_detail = await this.$store.dispatch('customerDetail', {
          uuid: user.uuid,
          mobile: this.mobileSelected
        })

        this.customer_detail_sale_transaction = customer_detail.saleTransaction
        this.customer_detail_data_pool = customer_detail.dataPool

        console.log(customer_detail)
      },
      async get_lead_month_info () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)
        console.log()
        const leadMonthInfoResult = await this.$store.dispatch('leadMonthInfo', {
          uuid: user.uuid,
          month: this.select_month_info_month,
          source: this.select_month_info_source
        })

        this.lead_month_info = leadMonthInfoResult
        this.assign_work_dialog_month = true

        console.log(leadMonthInfoResult)
      },
      async get_lead_month_info_filter () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)
        console.log()
        const leadMonthInfoResult = await this.$store.dispatch('leadMonthInfoFilter', {
          uuid: user.uuid,
          month: this.select_month_info_month,
          source: this.select_month_info_source,
          status: this.select_month_info_status
        })

        this.lead_month_info_filter = leadMonthInfoResult
        this.month_filter = true

        console.log(leadMonthInfoResult)
      },
      change_to_kerry_data() {
        this.tabs = 'kerry'
      },
      async getLeadListAdmin () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        this.loading_kerry = true

        console.log(user)
        const lead_list_result = await this.$store.dispatch('getLeadListAdmin', {
          uuid: user.uuid,
          keyword: this.search_keyword,
        })

        this.dataPool = lead_list_result
        this.dataPool_search = lead_list_result

        let dataPool_status_b = []
        for (let i = 0; i < lead_list_result.length; i++) {
          // console.log(lead_list_result)
          if (lead_list_result[i].status == 'B') {
            dataPool_status_b.push(lead_list_result[i])
          }
        }
        this.dataPool_status_b = dataPool_status_b
        this.loading_kerry = false

        console.log(lead_list_result)
      },
      async getRemoveReasonAdmin () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        this.loading_kerry = true

        console.log(user)
        const remove_reason_result = await this.$store.dispatch('getRemoveReasonAdmin', {
          uuid: user.uuid,
          keyword: this.search_keyword,
        })

        this.removeReasonData = remove_reason_result
        this.removeReasonDataTemplate = remove_reason_result
        this.remove_reason_unique_item = 'all'

        let unique = [...new Set(remove_reason_result.map(item => item.remove_reason))]
        let unique2 = unique.filter(elements => {
          return elements !== null;
        });
        unique2.push("all");
        this.remove_reason_unique = unique2
      },
      change_remove_reason() {
        if (this.remove_reason_unique_item == 'all'){
          this.removeReasonData = this.removeReasonDataTemplate
        }
        else {
          // this.removeReasonData = this.removeReasonDataTemplate.filter(function (el) {
          //   return el.remove_reason === this.remove_reason_unique_item
          // })
          this.removeReasonData = this.removeReasonDataTemplate.filter((user) => {
            return user.remove_reason === this.remove_reason_unique_item
          })
        }
      },
      async getAppointmentAdmin () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        this.loading_kerry = true

        console.log(user)
        const appointment_result = await this.$store.dispatch('getAppointmentAdmin', {
          uuid: user.uuid,
          keyword: this.search_keyword,
        })

        this.appointmentData = appointment_result
        // this.loading_kerry = false
        console.log(appointment_result)
      },
      async getSourceList () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        this.loading_kerry = true
        
        const source_list_result = await this.$store.dispatch('getSourceList', {
          uuid: user.uuid,
        })

        this.source = source_list_result

        console.log(source_list_result)
      },
      async getSaleTransaciontAdmin () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        this.loading_sale = true

        console.log(user)
        const lead_list_result = await this.$store.dispatch('getSaleTransaciontAdmin', {
          uuid: user.uuid,
          keyword: this.search_keyword,
        })

        this.saleTransactionData = lead_list_result
        this.loading_sale = false
      },
      async getSaleListAdmin () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        this.loading_sale_user = true

        console.log(user)
        const sale_list_result = await this.$store.dispatch('getSaleListAdmin', {
          uuid: user.uuid,
        })

        this.saleList = sale_list_result
        this.saleSelected = sale_list_result[0].uid
        this.loading_sale_user = false

        // console.log(saleList)
      },
      async getSaleListMonth () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        this.loading_sale_user = true

        console.log(user)
        const sale_list_result = await this.$store.dispatch('getSaleListMonth', {
          uuid: user.uuid,
        })

        this.leadListMonth = sale_list_result
        // this.loading_sale_user = false
      },
      async exportCreateTransactionCSV () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)
        const url_path = await this.$store.dispatch('exportCreateTransactionCSV', {
          uuid: user.uuid,
        })

        // console.log(url_path)
        window.open(url_path);
      },
      async exportDataPoolPSCSV () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)
        const url_path = await this.$store.dispatch('exportDataPoolPSCSV', {
          uuid: user.uuid,
        })

        // console.log(url_path)
        window.open(url_path);
      },
      async resetDAndAssignCron () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)
        this.loading_reset_d = true
        const url_path = await this.$store.dispatch('resetDAndAssignCron', {
          uuid: user.uuid,
          current_work: 150,
        })
        this.loading_reset_d = false
        this.reset_D_dialog = false
        console.log(url_path)
      },
      async assign_mobile_to_sale () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)
        console.log(this.saleSelected)
        const sale_list_result = await this.$store.dispatch('assign_mobile_to_sale_admin', {
          uuid: user.uuid,
          mobile: this.mobileSelected,
          sale_id: this.saleSelected,
          date: this.date_pick,
          status: this.status,
          note: this.assign_note,
          source: this.sourceSelect,
        })
        
        this.sourceSelect = ''
        this.assign_lead_dialog = false
        this.getLeadListAdmin()

        console.log(sale_list_result)
      },
      async assign_mobile_to_sale_multi () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        let param_obj = {
          uuid: user.uuid,
          mobile: this.selected_b,
          sale_id: this.saleSelected,
          date: this.date_pick,
          status: this.status,
          note_admin: this.assign_note,
        }

        let params = this.objectToFormData(param_obj)

        console.log(user)
        console.log(this.saleSelected)
        const sale_list_result = await this.$store.dispatch('assign_mobile_to_sale_multi', params)
        
        this.selected_b = []
        this.assign_lead_dialog_multi = false
        this.getLeadListAdmin()

        console.log(sale_list_result)
      },
      async assign_source_multi () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        let param_obj = {
          uuid: user.uuid,
          mobile: this.dataPool,
          source: this.sourceSelect,
        }

        let params = this.objectToFormData(param_obj)

        console.log(user)
        console.log(this.saleSelected)
        const sale_list_result = await this.$store.dispatch('assign_source_multi', params)
        
        this.assign_source_multi_dialog = false
        this.getLeadListAdmin()

        console.log(sale_list_result)
      },
      async assign_sale_multi () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)
        const seen = new Set();

        let mobile_select = []

        for (let item of this.dataPool) {
          const mobile = item.mobile
          if (mobile && !seen.has(mobile)) {
            seen.add(mobile);
            mobile_select.push(mobile);
          }
        }

        console.log(mobile_select)

        let param_obj = {
          uuid: user.uuid,
          sale_id: this.saleSelected,
          status: this.statusAfterSelected,
          mobile: mobile_select,
        }

        let params = this.objectToFormData(param_obj)

        console.log(user)
        console.log(this.saleSelected)
        const sale_list_result = await this.$store.dispatch('assign_sale_multi', params)
        this.statusFilterSelected = 'ทั้งหมด';
        this.statusAfterSelected = 'D';
        
        this.assign_sale_multi_dialog = false
        this.getLeadListAdmin()

        console.log(sale_list_result)
      },
      async assign_work_manual () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)
        console.log(this.saleSelected)
        const sale_list_result = await this.$store.dispatch('assign_work_manual', {
          uuid: user.uuid,
          work_count: this.work_count,
          sale_id: this.saleSelected,
          source: this.sourceSelect,
        })

        this.assign_work_dialog = false
        this.getLeadListAdmin()

        console.log(sale_list_result)
      },
      async assign_work_manual_month () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)
        console.log(this.saleSelected)
        const sale_list_result = await this.$store.dispatch('assign_work_manual_month', {
          uuid: user.uuid,
          work_count: this.work_count,
          sale_id: this.saleSelected,
          month: this.select_month_info_month,
          source: this.select_month_info_source,
        })

        this.assign_work_dialog_month = false
        this.getSaleListMonth()

        console.log(sale_list_result)
      },
      objectToFormData (obj = {}) {
          let formData = new FormData()
              for (let key in obj) {
                  if (typeof obj[key] === 'object' && !(obj[key] instanceof File)) {
                  for (let item in obj[key]) {
                      if (typeof obj[key][item] === 'object' && !(obj[key][item] instanceof File)) {
                          for (let index in obj[key][item]) {
                              formData.append(`${key}[${item}][${index}]`, obj[key][item][index])
                          }
                      } else {
                          formData.append(`${key}[${item}]`, obj[key][item])
                      }
                  }
              } else {
                  formData.append(key, obj[key])
              }
          }
          return formData
      },
      async importLead () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)

        let param_obj = {
          uuid: user.uuid,
          kerry_filename: null,
        }
        if (this.import_file != null) {
          param_obj.kerry_filename = this.import_file
          let params = this.objectToFormData(param_obj)
          const create_transaction_result = await this.$store.dispatch('importLead', params)
          console.log(create_transaction_result)
          this.snackbar_text = create_transaction_result
          this.snackbar = true
        }
        else {
          this.snackbar_text = 'กรุณาใส่ file'
          this.snackbar = true
        }

      },
      go_to_add_datapool() {
        this.$router.push('/addDataPool')
      }
    }
  }
</script>